import * as React from 'react';

import CcmCampaignFormCreatorfull from '../../../components/form/components/creatorfull/CcmCampaignFormCreatorfull';

import './ccm-campaign-create-creatorfull.scss';

type Props = {
  pageHeading: JSX.Element,
  organizationId: number,
  brandProfileId: number
};

const CcmCampaignCreateCreatorfull: React.FC<Props> = ({
  pageHeading,
  organizationId,
  brandProfileId
}): JSX.Element => (
  <div className="ccm-campaign-create-creatorfull">
    <CcmCampaignFormCreatorfull
      campaign={null}
      pageHeading={pageHeading}
      organizationId={organizationId}
      brandProfileId={brandProfileId}
    />
  </div>
);

export default CcmCampaignCreateCreatorfull;
